// Shared text hierarchy for detail and dashboard-style pages.
// Keep the scale small so similar content does not drift between screens.
const typography = {
  micro: {fontSize: 10},
  caption: {fontSize: 11},
  captionStrong: {fontSize: 11, fontWeight: '600'},
  label: {fontSize: 12, fontWeight: '600'},
  body: {fontSize: 13},
  bodyMedium: {fontSize: 13, fontWeight: '500'},
  bodyStrong: {fontSize: 13, fontWeight: '600'},
  value: {fontSize: 14},
  sectionTitle: {fontSize: 15, fontWeight: '600'},
  cardMetric: {fontSize: 18, fontWeight: '700'},
  heroMetric: {fontSize: 22, fontWeight: '800'},
  display: {fontSize: 28, fontWeight: '900'},
};

export default typography;
